import React from "react"
import type { CadastroBannerFornecedorModel } from "../models/cadasBannerFornecedorModel"
import { CadastroBannerFornecedorInicial } from "../models/cadasBannerFornecedorModel"
import type { CadastroBannerFornecedorActions } from "./cadasBannerFornecedorActions"

type CadasBannerFornecedorContextType = {
    dados: CadastroBannerFornecedorModel
    dispatch: React.Dispatch<CadastroBannerFornecedorActions>
    salvar: () => Promise<void>
    excluir: (id: number) => Promise<void>
    upload: (arquivo: File) => Promise<void>
    erroCarregamento: string | null
}

export const CadasBannerFornecedorContext = React.createContext<CadasBannerFornecedorContextType>({
    dados: CadastroBannerFornecedorInicial,
    dispatch: () => undefined,
    salvar: async () => undefined,
    excluir: async () => undefined,
    upload: async () => undefined,
    erroCarregamento: null,
})
